import { TemplateBackstageLogoIcon, FeaturedDocsCard, HomePageToolkit, ComponentAccordion, HomePageRecentlyVisited, HomePageTopVisited } from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import React, { useState } from 'react';
import { Grid, makeStyles, Box, Tabs, Tab, Button } from '@material-ui/core';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Content, Page, InfoCard } from '@backstage/core-components';
import SNowLogo from './icons/SNowLogo';
import SailPointLogo from './icons/SailPointLogo';
import AzureLogo from './icons/AzureLogo';
import AzureDevOpsLogo from './icons/AzureDevOpsLogo';
import TerraformLogo from './icons/TerraformLogo';
import SonarqubeLogo from './icons/SonarqubeLogo';
import ESILogo from './icons/ESILogo';
import FortifyLogo from './icons/FortifyLogo';
import CyberarkLogo from './icons/CyberarkLogo';
import WizLogo from './icons/WizLogo';
import SnykLogo from './icons/SnykLogo';
import { NewAnnouncementBanner } from '@procore-oss/backstage-plugin-announcements';
import { McpServersTable } from '../ai-central/components/McpServersTable';
import { AnnouncementsCard } from './AnnouncementsCard';
import StarIcon from '@material-ui/icons/Star';
import BuildIcon from '@material-ui/icons/Build';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import HistoryIcon from '@material-ui/icons/History';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles(theme => ({
  searchBarInput: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '4px',
    boxShadow: theme.shadows[1],
  },
  searchBarOutline: {
    borderStyle: 'none'
  },
  searchSection: {
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
  cardWithBorder: {
    boxSizing: 'border-box',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },
  blueAccent: {
    borderLeftColor: theme.palette.primary.main,
  },
  orangeAccent: {
    borderLeftColor: '#ff9800',
  },
  purpleAccent: {
    borderLeftColor: '#9c27b0',
  },
  greenAccent: {
    borderLeftColor: '#4caf50',
  },
  grayAccent: {
    borderLeftColor: theme.palette.text.secondary,
  },
  tabsContainer: {
    marginBottom: theme.spacing(1),
  },
  tabPanel: {
    padding: 0,
  },
  cardTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  cardTitleIcon: {
    fontSize: '1.25rem',
  },
  cardRow: {
    display: 'flex',
    alignItems: 'stretch',
    '& > *': {
      flex: 1,
    },
  },
  announcementsWrapper: {
    '& > div': {
      height: '100%',
    },
  },
  seeAllButton: {
    textTransform: 'none',
  },
  cardGridItem: {
    display: 'flex',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    '& > *': {
      flex: '1 1 auto',
      display: 'flex !important',
      flexDirection: 'column !important',
      height: '100% !important',
      minHeight: 0,
    },
    '& .MuiCard-root': {
      height: '100% !important',
      display: 'flex !important',
      flexDirection: 'column !important',
      margin: 0,
    },
    '& .MuiCardContent-root': {
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
    },
    '& .MuiCardHeader-root': {
      flex: '0 0 auto',
    },
  },
}));

const tools1 = [
  { url: 'https://avidxchange.service-now.com/sp?id=sc_category', label: 'Service Now', icon: <SNowLogo />, },
  { url: 'https://avidxchange.identitynow.com/ui/d/request-center/apps', label: 'Sailpoint', icon: <SailPointLogo />, }
];

const tools2 = [
  { url: 'https://portal.azure.com', label: 'Azure', icon: <AzureLogo /> },
  { url: 'https://dev.azure.com/avidxchange/', label: 'Azure DevOps', icon: <AzureDevOpsLogo /> },
  { url: 'https://app.terraform.io/', label: 'Terraform', icon: <TerraformLogo /> },
  { url: 'https://observe.avidxchange.com/', label: 'OP', icon: <TemplateBackstageLogoIcon /> },
  { url: 'https://sonarqube.avidxchange.com/', label: 'SonarQube', icon: <SonarqubeLogo /> },
  { url: 'https://esi.learnondemand.net/', label: 'ESI', icon: <ESILogo /> }
];

const tools3 = [
  { url: 'https://ams.fortify.com/', label: 'Fortify', icon: <FortifyLogo /> },
  { url: 'https://app.snyk.io/', label: 'Snyk', icon: <SnykLogo /> },
  { url: 'https://abd4132.id.cyberark.cloud/my?customerId=ABD4132', label: 'CyberArk', icon: <CyberarkLogo /> },
  { url: 'https://app.wiz.io', label: 'Wiz', icon: <WizLogo /> },
];

const tools4 = [
  { url: 'https://dev.azure.com/avidxchange/Architecture%20Center%20of%20Excellence/_wiki/wikis/Architecture-Center-of-Excellence.wiki/18505/AvidXchange-Official-Domain-Model', label: 'ODM Home', icon: <TemplateBackstageLogoIcon /> },
  { url: 'https://avidxchangedomainmodel.azurewebsites.net/', label: 'Arch Views', icon: <TemplateBackstageLogoIcon /> },
  { url: 'https://apps.powerapps.com/play/e/default-55d96f5e-2b75-4762-ae08-11de584d8e83/a/49c0d616-7eb2-4ee9-b89a-526d0a544c4f?tenantId=55d96f5e-2b75-4762-ae08-11de584d8e83', label: 'ARB Intake', icon: <TemplateBackstageLogoIcon /> },
  { url: 'https://dev.azure.com/avidxchange/Architecture%20Center%20of%20Excellence/_wiki/wikis/Architecture-Center-of-Excellence.wiki/18062/Standards', label: 'Standards', icon: <TemplateBackstageLogoIcon /> },
];

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

interface CardTitleWithIconProps {
  icon: React.ReactNode;
  title: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`visits-tabpanel-${index}`}
      aria-labelledby={`visits-tab-${index}`}
      {...other}
    >
      <Box>{children}</Box>
    </div>
  );
}

function CardTitleWithIcon({ icon, title }: CardTitleWithIconProps) {
  const classes = useStyles();
  return (
    <Box className={classes.cardTitle}>
      <Box className={classes.cardTitleIcon}>{icon}</Box>
      <span>{title}</span>
    </Box>
  );
}

export const HomePage = () => {
  const classes = useStyles();
  const [visitTabValue, setVisitTabValue] = useState(0);

  const ExpandedComponentAccordion = (props: any) => (
    <ComponentAccordion {...props} />
  );

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container direction="column">
            <Grid container item xs={12}>
              <NewAnnouncementBanner />
            </Grid>
            
            {/* Search bar */}
            <Grid container item xs={12} justifyContent="center" className={classes.searchSection}>
              <Grid item xs={12} md={8}>
                <HomePageSearchBar
                  InputProps={{ classes: { root: classes.searchBarInput, notchedOutline: classes.searchBarOutline } }}
                  placeholder="Search"
                />
              </Grid>
            </Grid>

            <Grid container xs={12} spacing={2}>
              {/* Row 1: Featured Docs + Quick Access */}
              <Grid item xs={12}>
                <Grid container spacing={2} className={classes.cardRow}>
                  <Grid item xs={12} md={6} className={classes.cardGridItem}>
                    <Box className={`${classes.cardWithBorder} ${classes.blueAccent} ${classes.cardWrapper}`}>
                      <FeaturedDocsCard filter={{
                        'spec.type': 'website',
                        'metadata.name': 'avid-developer-portal',
                      }} />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} className={classes.cardGridItem}>
                    <Box className={`${classes.cardWithBorder} ${classes.grayAccent} ${classes.cardWrapper}`}>
                      <InfoCard title={<CardTitleWithIcon icon={<StarIcon />} title="Quick Access" />} variant="gridItem">
                        <Tabs
                          value={visitTabValue}
                          onChange={(_event, newValue) => setVisitTabValue(newValue)}
                          indicatorColor="primary"
                          textColor="primary"
                          variant="fullWidth"
                          className={classes.tabsContainer}
                        >
                          <Tab icon={<TrendingUpIcon />} label="Top Visited" />
                          <Tab icon={<HistoryIcon />} label="Recent" />
                        </Tabs>
                        <TabPanel value={visitTabValue} index={0}>
                          <HomePageTopVisited numVisitsOpen={5} />
                        </TabPanel>
                        <TabPanel value={visitTabValue} index={1}>
                          <HomePageRecentlyVisited numVisitsOpen={5} />
                        </TabPanel>
                      </InfoCard>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              {/* Row 2: Announcements (full width) */}
              <Grid item xs={12}>
                <Box className={`${classes.cardWithBorder} ${classes.orangeAccent} ${classes.cardWrapper}`}>
                  <AnnouncementsCard max={6} />
                </Box>
              </Grid>

              {/* Row 3: MCP Servers (full width) */}
              <Grid item xs={12}>
                <Box className={`${classes.cardWithBorder} ${classes.purpleAccent} ${classes.cardWrapper}`}>
                  <McpServersTable variant="gridItem" />
                </Box>
              </Grid>

              {/* Row 4: Toolkit (full width) */}
              <Grid item xs={12}>
                <Box className={`${classes.cardWithBorder} ${classes.greenAccent}`}>
                  <InfoCard title={<CardTitleWithIcon icon={<BuildIcon />} title="Toolkit" />} noPadding>
                    <Grid item>
                      <HomePageToolkit title="IAM and Service Desk" tools={tools1} Renderer={ExpandedComponentAccordion} />
                      <HomePageToolkit title="Cloud and Delivery" tools={tools2} Renderer={ExpandedComponentAccordion} />
                      <HomePageToolkit title="Security" tools={tools3} Renderer={ExpandedComponentAccordion} />
                      <HomePageToolkit title="Architecture" tools={tools4} Renderer={ExpandedComponentAccordion} />
                    </Grid>
                  </InfoCard>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider >
  );
};
